import { IconButton, Tooltip } from '@chakra-ui/react'
import { t } from '@lingui/core/macro'
import type { FC } from 'react'
import { MdOutlineThumbDown, MdOutlineThumbUp } from 'react-icons/md'

type Props = {
  onUp: () => void
  onDown: () => void
}

export const ThumbsButtons: FC<Props> = ({ onUp, onDown }) => {
  return (
    <>
      <Tooltip label={t`Thumbs up`}>
        <IconButton
          aria-label={t`Thumbs up`}
          icon={<MdOutlineThumbUp />}
          size="xs"
          variant="ghost"
          color="greys.300"
          onClick={(e) => {
            e.stopPropagation()
            onUp()
          }}
        />
      </Tooltip>
      <Tooltip label={t`Thumbs down`}>
        <IconButton
          aria-label={t`Thumbs down`}
          icon={<MdOutlineThumbDown />}
          size="xs"
          variant="ghost"
          color="greys.300"
          onClick={(e) => {
            e.stopPropagation()
            onDown()
          }}
        />
      </Tooltip>
    </>
  )
}
